import React, { useEffect, useState } from 'react';

import { Web } from '@mui/icons-material';
import { Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { ExpensesMenuItem, SubHeader, Footer } from '../../components';

import './styles.scoped.css';

const ExpenseEntry = () => {
  const navigate = useNavigate();
  const appAccess = useSelector(state => state.admin?.user?.appAccess);
  const { clientMenu, subHeader } = useSelector(state => state.expenseEntry);
  const [currentExpenseRole, setCurrentExpenseRole] = useState('');

  const onPress = item => {
    navigate(item.to);
  };

  useEffect(() => {
    const access = appAccess?.items?.filter(app => app.appId?.name === 'Expense Entry')?.[0];
    if (access && access.roleId) {
      setCurrentExpenseRole(access?.roleId?.id);
    }
  }, [appAccess, clientMenu]);

  return (
    <>
      <SubHeader
        text="Expenses"
        buttons={[{ icon: <Web sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/dashboard') }]}
        popoverTitle="Need help with your Expenses?"
      />
      <Container className="wrap">
        <h1 className="header">{subHeader}</h1>
        <div key={clientMenu.menuHeader}>
          <Row className="row" key={`${clientMenu.menuHeader}-row`}>
            {currentExpenseRole === '8' || currentExpenseRole === '9' || currentExpenseRole === '32' || currentExpenseRole === '33'
              ? clientMenu.menuItems.map(
                i =>
                  i.to.includes('/expense-entry/mobile-driver-solutions') && (
                    <ExpensesMenuItem key={i.text} text={i.text} onPress={() => onPress(i)} disabled={i.disabled} />
                  ),
              )
              : null}

            {currentExpenseRole === '30' || currentExpenseRole === '31' || currentExpenseRole === '32' || currentExpenseRole === '33'
              ? clientMenu.menuItems.map(
                i =>
                  i.to.includes('/expense-entry/driver-management-services') && (
                    <ExpensesMenuItem
                      styles={{ backgroundColor: '#53565a', color: '#ffff' }}
                      key={i.text}
                      text={i.text}
                      onPress={() => onPress(i)}
                      disabled={i.disabled}
                    />
                  ),
              )
              : null}

            {currentExpenseRole === '33'
              ? clientMenu.menuItems.map(
                i =>
                  i.to.includes('/expense-entry/expense-maintenance') && (
                    <ExpensesMenuItem
                      styles={{ color: '#da0f2e' }}
                      key={i.text}
                      text={i.text}
                      onPress={() => onPress(i)}
                      disabled={i.disabled}
                    />
                  ),
              )
              : null}
          </Row>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default ExpenseEntry;
